import { graphql } from 'gql';

export const bimWorkOrderVersionsGql = graphql(`
    query bimWorkOrderVersions($workOrderId: Long!, $order: [BimWorkOrderVersionListItemSortInput!]) {
        bimWorkOrderVersions(workOrderId: $workOrderId, order: $order) {
            workOrderVersionItem {
                id
                internalNumber
                signingDate
            }
            workOrderChangeItem {
                id
                internalNumber
                signingDate
            }
        }
    }
`);

export const bimWorkOrderVersionGql = graphql(`
    query bimWorkOrderVersion($workOrderVersionId: Long!) {
        bimWorkOrderVersion(workOrderVersionId: $workOrderVersionId) {
            data {
                id
                amountWithoutTax
                tax
                remainder
                startDate
                finishDate
                status
                subject
                internalNumber
                signingDate
                contractor
                workOrderChangeNumber
                workOrderChangeSigningDate
                amountWithTax
                seasonDistributions {
                    workOrderVersionSeasonId
                    year
                    seasonValue
                }
            }
        }
    }
`);

export const bimWorkOrderVersionObjectsGql = graphql(`
    query bimWorkOrderVersionObjects(
        $order: [BimWorkOrderVersionObjectDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimWorkOrderVersionObjectDataFilterInput
        $workOrderVersionId: Long!
    ) {
        bimWorkOrderVersionObjects(
            workOrderVersionId: $workOrderVersionId
            order: $order
            skip: $skip
            take: $take
            where: $where
        ) {
            items {
                fromWorkOrder
                id
                contractId
                constructionType {
                    id
                    code
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                parentId
                rootObjectId
                status
                name
                hasGuaranteedVolume
                workOrderVersionId
                objectSeasonDistributions {
                    id
                    seasonValue
                    season {
                        id
                        workOrderVersionId
                        year
                    }
                }
                rationale
            }
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
        }
    }
`);

export const bimWorkOrderVersionOtherPricesGql = graphql(`
    query bimWorkOrderVersionOtherPrices(
        $skip: Int
        $take: Int
        $workOrderVersionId: Long!
        $workOrderVersionRootObjectId: Long!
        $where: BimWorkOrderVersionOtherPriceDataFilterInput
        $order: [BimWorkOrderVersionOtherPriceDataSortInput!]
    ) {
        bimWorkOrderVersionOtherPrices(
            skip: $skip
            take: $take
            workOrderVersionId: $workOrderVersionId
            workOrderVersionRootObjectId: $workOrderVersionRootObjectId
            where: $where
            order: $order
        ) {
            totalCount
            items {
                id
                contractOtherCostId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                isActKC2Price
                hasEmptyActPlanCost
                hasEmptyActAcceptedCost
                planValue {
                    others
                    total
                    hasErrors
                    errors
                }
                completedValue {
                    others
                    total
                    hasErrors
                    errors
                }
                remainderValue {
                    others
                    total
                    hasErrors
                    errors
                }
                actKC2OtherCosts {
                    actKC2Id
                    costPlan
                    costAccepted
                    comment
                }
                completedOtherDeviation
            }
        }
    }
`);

export const bimWorkOrderVersionPriceRowsGql = graphql(`
    query bimWorkOrderVersionPriceRows($workOrderVersionPriceId: Long!, $priceLevel: BimPriceLevelEnum) {
        bimWorkOrderVersionPriceRows(workOrderVersionPriceId: $workOrderVersionPriceId, priceLevel: $priceLevel) {
            items {
                id
                workOrderVersionId
                workOrderVersionPriceId
                type
                sectionId
                sectionName
                value {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    mz
                    total
                    oz
                    tzr
                }
            }
        }
    }
`);

export const bimWorkOrderVersionPriceRowCodeFilterGql = graphql(`
    query bimWorkOrderVersionPriceRowCodeFilter(
        $workOrderVersionPriceId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderVersionPriceRowCodeFilter(
            workOrderVersionPriceId: $workOrderVersionPriceId
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderVersionPriceRowNameFilterGql = graphql(`
    query bimWorkOrderVersionPriceRowNameFilter(
        $workOrderVersionPriceId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderVersionPriceRowNameFilter(
            workOrderVersionPriceId: $workOrderVersionPriceId
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderVersionPriceCodeFilterGql = graphql(`
    query bimWorkOrderVersionPriceCodeFilter(
        $workOrderVersionId: Long!
        $workOrderVersionRootObjectId: Long!
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderVersionPriceCodeFilter(
            workOrderVersionId: $workOrderVersionId
            workOrderVersionRootObjectId: $workOrderVersionRootObjectId
            chapter: $chapter
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderVersionPriceNameFilterGql = graphql(`
    query bimWorkOrderVersionPriceNameFilter(
        $workOrderVersionId: Long!
        $workOrderVersionRootObjectId: Long!
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderVersionPriceNameFilter(
            workOrderVersionId: $workOrderVersionId
            workOrderVersionRootObjectId: $workOrderVersionRootObjectId
            chapter: $chapter
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderVersionPriceObjectNameFilterGql = graphql(`
    query bimWorkOrderVersionPriceObjectNameFilter(
        $workOrderVersionId: Long!
        $workOrderVersionRootObjectId: Long!
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderVersionPriceObjectNameFilter(
            workOrderVersionId: $workOrderVersionId
            workOrderVersionRootObjectId: $workOrderVersionRootObjectId
            chapter: $chapter
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderVersionPriceRevisionNameFilterGql = graphql(`
    query bimWorkOrderVersionPriceRevisionNameFilter(
        $revisionType: WorkOrderPriceRevisionTypeEnum
        $workOrderVersionPriceId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderVersionPriceRevisionNameFilter(
            revisionType: $revisionType
            workOrderVersionPriceId: $workOrderVersionPriceId
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderVersionPriceRevisionCodeFilterGql = graphql(`
    query bimWorkOrderVersionPriceRevisionCodeFilter(
        $revisionType: WorkOrderPriceRevisionTypeEnum
        $workOrderVersionPriceId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderVersionPriceRevisionCodeFilter(
            revisionType: $revisionType
            workOrderVersionPriceId: $workOrderVersionPriceId
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimActsKC2VersionOtherGql = graphql(`
    query bimActsKC2VersionOther(
        $order: [BimActKC2VersionOtherItemDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimActKC2VersionOtherItemDataFilterInput
        $workOrderVersionId: Long!
        $workOrderVersionObjectId: Long
    ) {
        bimActsKC2VersionOther(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderVersionId: $workOrderVersionId
            workOrderVersionObjectId: $workOrderVersionObjectId
        ) {
            items {
                id
                status
                number
                date
                correctionDate
                fullNumber
                isCorrection
                isInactive
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimActKC2VersionOtherTotalsGql = graphql(`
    query bimActKC2VersionOtherTotals($actKC2VersionOtherId: Long!) {
        bimActKC2VersionOtherTotals(actKC2VersionOtherId: $actKC2VersionOtherId) {
            items {
                id
                workOrderVersionSeasonId
                isInflation
                workOrderVersionActiveSeasonId
                name
                total
                sortOrder
            }
        }
    }
`);

export const bimActKC2VersionOtherGql = graphql(`
    query bimActKC2VersionOther($actKC2VersionOtherId: Long!) {
        bimActKC2VersionOther(actKC2VersionOtherId: $actKC2VersionOtherId) {
            data {
                id
                contractId
                workOrderVersionId
                constructionType {
                    id
                    code
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                workOrderVersionObject {
                    workOrderVersionId
                    fromWorkOrder
                    id
                    contractId
                    constructionType {
                        id
                        code
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    parentId
                    rootObjectId
                    status
                    name
                    hasGuaranteedVolume
                    objectSeasonDistributions {
                        id
                        season {
                            id
                            workOrderVersionId
                            year
                        }
                        seasonValue
                    }
                    rationale
                    order
                }
                workOrderVersionSeason {
                    workOrderVersionId
                    id
                    year
                }
                status
                number
                date
                startDate
                finishDate
                contractor
                contractorAddress
                createdAt
                updatedAt
                authoredBy
                updatedBy
                statusFollowers
                hasPlanValues
            }
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            result
            message
            code
        }
    }
`);

export const bimWorkOrderVersionTotalsRow = graphql(`
    query bimWorkOrderVersionTotals(
        $workOrderVersionId: Long!
        $constructionTypeId: Int
        $chapter: BimChapterEnum
        $workOrderVersionObjectId: Long
        $useInPrices: Boolean!
        $priceLevel: BimPriceLevelEnum
    ) {
        bimWorkOrderVersionTotals(
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            chapter: $chapter
            workOrderVersionObjectId: $workOrderVersionObjectId
            useInPrices: $useInPrices
            priceLevel: $priceLevel
        ) {
            items {
                completedValue {
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                planValue {
                    code
                    emm
                    mp
                    mz
                    name
                    nr
                    op
                    others
                    oz
                    ozp
                    quantity
                    smrTotal
                    sp
                    total
                    tzr
                    unit
                    zpm
                }
                name
            }
            totalCount
        }
    }
`);

export const bimWorkOrderVersionChapterPriceCountsGql = graphql(`
    query bimWorkOrderVersionChapterPriceCounts(
        $workOrderVersionId: Long!
        $constructionTypeId: Int
        $workOrderVersionRootObjectId: Long
    ) {
        bimWorkOrderVersionChapterPriceCounts(
            workOrderVersionId: $workOrderVersionId
            constructionTypeId: $constructionTypeId
            workOrderVersionRootObjectId: $workOrderVersionRootObjectId
        ) {
            data {
                chapter
                pricesCount
            }
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            result
            message
            code
        }
    }
`);

export const bimWorkOrderVersionPriceStatesGql = graphql(`
    query bimWorkOrderVersionPriceStates($chapter: BimChapterEnum!, $workOrderVersionObjectId: Long!) {
        bimWorkOrderVersionPriceStates(chapter: $chapter, workOrderVersionObjectId: $workOrderVersionObjectId) {
            data {
                hasExcessCompletedTotalSMR
                hasExcessCompletedOthers
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
